// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2020-09-04T14:34:09+00:00
//    Cause:          Commit 291aa544a3ea3ac94e5818e9e11ceb0b95992645 by robert-kelly
//    Deployment ID:  93798
//    Project:        167
//    Environment:    334 - master
//    MD5:            6446b7ee3fa184f5e4a07b9a588dea65
//    Signature:      eyJpdiI6IlRQN21vQ3VOamJPTWQwVFBneEMrY2c9PSIsInZhbHVlIjoidXFYckZMYzJ1S2E5bzNlSm5YcklaVkU1cFVlamZGQ09DREI3a0ZabTRxcDdtUE5WeXFPem5lOElEUEMyaWNyRFRjYmRXaGlSbUo2TzkxNDVkWnNnVGNZYVI0UlNrNVZCM2wwOHJ2WlcrYnZlbDFuYzNkR1gzWWtBK2FwdUsycjJyU1p6ZXZybTY0cFY5NjRvK2N6MFRcL05wa0tSQzJWR1U3Sng4czFyUVFvakt6d2ZFRDJcL3JyYTVBeDIxcWh6RGhXcWpLY1ozMWVpWkhDSk9KNzdKWkxlRU9VcCtFSzZNMVdiUnMxdXpBODBWM2xZZXNOWDJ1dHBNbTBKdzBUTTM4cndzWnF6aUJ0NmgzUWN2aFg3Z24wNFE3bDNGZ1RBVTJWNWpPXC9tRTc4OE1IVUtaXC9JdG1rYlFMYzFWSDFkWlY4aFVQK0orS2JLYjBZRkpKbUxMVGJzaGJJcjRjSVFTTkZIUVFaOXlLWkpMS3FRRkxmNDREM0RVTitBMHF0VHZRb0hpOWJNdTdHd3JKeis1eVFtblI5NDRFZk5pYmJzN3c4NzhDVnk2eWJoMndcLzA4S3p0bmd3VVJHeGlGNFp6dVAyIiwibWFjIjoiYTgyNTRlYWEwY2RiMDhiZGQzNThhNzY0YjU0OTZjYzgzNDhhMWQ3NzU5YjgyMzM1YmIzM2I4YzgzZjdkY2UyMiJ9
// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2020-01-30T14:02:19+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  60404
//    Project:        167
//    Environment:    334 - master
//    MD5:            152115c0301c25cb615ad690ccad87b9
//    Signature:      eyJpdiI6IlMzdGpPY2dXcnN1ejlhb1I0Slg4OWc9PSIsInZhbHVlIjoiY3Q5Z3MyK0JOMjBVOTZSUDh6Q1ZLYk5zQXZrVWRsQzdjdnRpa2w0ZGhZaUJXQ2ZFcUJCRElpelJLYVRFV21PSmRzMU91VzZsSWdUdzhpTEZraExDMDFkb3BRbitRVlNveUMxTnhLY2grMkNXbDE5YU9lOVNER3pFa2VNQjk4T1J5aFI5UFFmY3NnbUZHXC9waEJTUlpCODRwNUdpMGphXC9zXC9uZ3BTUDV4SlEzZnhjblB2QWFOMUxnSXV2Y2tLWVFOTDNMZXFxclRNdUNGdHV4SEdlV3ptaW91SzA3RStUdFE5Q2NYUEgrODUxQ2hqdHV3SlNqZkF6T2hlRWx6RDQxcHJwWDAzMlEzVmpxOW83Yndhc3dyc0ZiNWxJZm5lNTU4VTk3ZlE4RzFLYVIxdElnYVNjR0ZSZ2VUVjZFalwvOE9CMFR1aXJKZDNzMGZFQXV5bHp3VW45bmZiWjBcL29ZUUh4MG1nRnhOYkExdk1oUGhndjZGMmRIZU51UG9YMmY2QlgiLCJtYWMiOiI3ZDdiYmI0ZDRkZDNjNzQ4NzhlOWQ1ZWZlNzFmYWY0ZWNmMTZkOWJlZDIxMzQ2ZDg2ZTExMTA0YTlhZTU1ZDg1In0=
/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

 const challengeEl = document.getElementsByClassName('shopify-challenge__container')[0];

 if (challengeEl) {
   if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
   }

   window.scrollTo({ top: 0, behavior: 'smooth' });
}